import transform from 'lodash-es/transform';
import pickBy from 'lodash-es/pickBy';
import get from 'lodash-es/get';
import isNull from 'lodash-es/isNull';
import { WorksheetActionModelSelector } from '@pbx/helpers/worksheets/action-types';
import defaultsDeep from 'lodash-es/defaultsDeep';
import i18n from '@/plugins/i18n';

export class Base {
  constructor(item) {
    this.id = item.id || null;
    this.type = item.type || '';
    this.name = item.name || '';
    this.position = item.position || { x: 0, y: 0 };
    /**
     * Используем Object.assign, чтобы преобразовать в объект.
     * если поля params или options ничего не содержат, они прилетят с бека как Array
     * @type {{options: Object, params: Object}}
     */
    this.data = {
      params: Object.assign({}, get(item, 'data.params', {})),
      options: Object.assign({}, get(item, 'data.options', {}))
    };
  }

  getName() {
    return this.name || i18n.t(`pbx.worksheet.action.type.${this.type}`);
  }

  getOptions() {
    return this.data.options || {};
  }

  setOptions(options = {}) {
    return WorksheetActionModelSelector.getFrontendModelByType(this.type, {
      ...this,
      data: {
        ...this.data,
        options: options
      }
    });
  }

  getFreeOptions() {
    return pickBy(this.getOptions(), val => isNull(val));
  }

  hasFreeOptions() {
    return Object.keys(this.getFreeOptions()).length > 0;
  }

  isAllowedIncomingConnection() {
    return true;
  }

  createOption(option) {
    const data = defaultsDeep({ options: option }, this.data);
    const merge_item = defaultsDeep({ data: data }, this);

    return WorksheetActionModelSelector.getFrontendModelByType(this.type, merge_item);
  }

  removeOption(name = '') {
    const params = this.data.params || {};
    const options = transform(this.data.options, (result, value, key) => {
      if (key !== name) {
        result[key] = value;
      }
    });

    const merge_item = {
      ...this,
      data: {
        params,
        options
      }
    };

    return WorksheetActionModelSelector.getFrontendModelByType(this.type, merge_item);
  }

  toBaseBackend() {
    const source = Object.assign({}, this);
    return transform(source, function(result, value, key) {
      if (key === 'position') {
        result['position_x'] = value['x'];
        result['position_y'] = value['y'];
      } else if (key === 'data') {
        result['data'] = {
          params: pickBy(value['params'], val => !isNull(val)),
          options: pickBy(value['options'], val => !isNull(val))
        };
      } else {
        result[key] = value;
      }
    });
  }

  toBackend() {
    return WorksheetActionModelSelector.getBackendModelByType(this.type, this.toBaseBackend());
  }
}
